var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask",
    d: "M0,0H60V60H0Z",
    transform: "translate(573 232)",
    fill: "#c7cdd1",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7828",
    "data-name": "Rectangle 7828",
    width: 43.627,
    height: 37.039,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6548",
    "data-name": "Mask Group 6548",
    transform: "translate(-573 -232)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32343",
    "data-name": "Group 32343",
    transform: "translate(581.187 243.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32345",
    "data-name": "Group 32345",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34498",
    "data-name": "Path 34498",
    d: "M36.788,18.487a2.714,2.714,0,1,1-2.41-2.979,2.723,2.723,0,0,1,2.41,2.979",
    transform: "translate(-3.476 -1.716)",
    fill: "#4b73f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34499",
    "data-name": "Path 34499",
    d: "M0,25.948H43.627V0H0Zm23.92-13-1.645.622a6.874,6.874,0,0,1-.836,2.01l.72,1.6L20.721,18.62l-1.6-.72a6.874,6.874,0,0,1-2.01.836l-.631,1.645H14.434l-.614-1.645a6.874,6.874,0,0,1-2.01-.836l-1.609.72L8.761,17.18l.711-1.6a6.852,6.852,0,0,1-.827-2.01L7,12.947V10.9l1.645-.622a6.852,6.852,0,0,1,.827-2.01L8.761,6.66,10.2,5.22l1.609.72a6.641,6.641,0,0,1,2.01-.836l.614-1.645h2.045L17.111,5.1a6.874,6.874,0,0,1,2.01.836l1.6-.72L22.161,6.66l-.72,1.609a6.874,6.874,0,0,1,.836,2.01l1.645.622Zm12.547,4.891-1.2.32a4.724,4.724,0,0,1-.738,1.343l.391,1.174-1.12.907-1.067-.622a5.267,5.267,0,0,1-1.467.436L30.7,22.5l-1.432-.151-.311-1.2a4.608,4.608,0,0,1-1.343-.738L26.43,20.8l-.907-1.12.622-1.067a5.041,5.041,0,0,1-.436-1.476l-1.1-.56.151-1.432,1.2-.311a4.848,4.848,0,0,1,.729-1.352L26.305,12.3l1.12-.9,1.076.622a4.985,4.985,0,0,1,1.467-.436l.56-1.1,1.432.151.32,1.2a4.724,4.724,0,0,1,1.343.738l1.183-.391.9,1.12-.622,1.076a4.985,4.985,0,0,1,.436,1.467l1.1.56ZM15.457,8.074a3.846,3.846,0,1,0,3.85,3.841,3.848,3.848,0,0,0-3.85-3.841",
    transform: "translate(0 0)",
    fill: "#4b73f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7826",
    "data-name": "Rectangle 7826",
    width: 8.866,
    height: 4.446,
    transform: "translate(17.381 32.593)",
    fill: "#002c77"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7827",
    "data-name": "Rectangle 7827",
    width: 43.627,
    height: 2.668,
    transform: "translate(0 27.843)",
    fill: "#5048bf"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.b8c23c6cbc7cad28e30e4d307b82caad.svg";
export { ForwardRef as ReactComponent };